"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Menu = _interopRequireDefault(require("./Menu.style"));

var _dec, _class;

let Menu = (_dec = (0, _reactJss.default)(_Menu.default), _dec(_class = (0, _reactClickOutside.default)(_class = class Menu extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(value) {
    const {
      id,
      visibility
    } = this.props;
    if (visibility === 'disabled') return;
    const error = false;
    this.props.onClick({
      id,
      value,
      error
    });
  } // Handler for click outside of component


  handleClickOutside(e) {
    const {
      visibility,
      type
    } = this.props;
    if (type === 'sideBar') return;

    if (visibility === 'visible') {
      this.props.onClose(e);
    }
  }

  render() {
    const {
      id,
      classes,
      className,
      children,
      width,
      activeItem,
      openType,
      visibility,
      onMouseMove,
      size
    } = this.props;
    return _react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(className, classes.menu, classes[size], {
        openUp: openType === 'top'
      }, {
        hidden: visibility === 'hidden'
      }, {
        disabled: visibility === 'disabled'
      }),
      onMouseMove: onMouseMove,
      style: {
        maxWidth: width
      }
    }, _react.default.Children.map(children, child => {
      const params = {
        onClick: this.handleClick,
        size
      };

      if (activeItem && child.type.displayName === 'JssContextSubscriber') {
        params.activeItem = activeItem;
      }

      return _react.default.cloneElement(child, params);
    }));
  }

}) || _class) || _class);
Menu.defaultProps = {
  children: null,
  id: null,
  visibility: 'visible',
  error: false,
  type: 'menu',
  onClick: () => {},
  onClose: () => {},
  onMouseMove: () => {},
  size: 'medium'
};
var _default = Menu;
exports.default = _default;